import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-info-dialog',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.scss'
})
export class InfoDialogComponent {
  @Input() title!: string;
  @Input() message!: string;
  @Input() confirmActionLabel!: string;

  constructor(private modalService: NgbActiveModal) { }

  close() {
    this.modalService.dismiss();
  }

}
